// extracted by mini-css-extract-plugin
module.exports = {"category":"T_dx","wrapp":"T_dy","category__wrapper":"T_dz"};